var normalizeComponent = require("!../../../../../../shared/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../shared/node_modules/vue-loader/lib/selector?type=script&index=0!./chat_group_header.vue"
import __vue_script__ from "!!babel-loader!../../../../../../shared/node_modules/vue-loader/lib/selector?type=script&index=0!./chat_group_header.vue"
/* template */
import __vue_template__ from "!!../../../../../../shared/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-49fb7206\",\"hasScoped\":false,\"buble\":{\"transforms\":{}}}!../../../../../../shared/node_modules/vue-loader/lib/selector?type=template&index=0!./chat_group_header.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/messenger/chat_group_header.vue
// module id = 18
// module chunks = 0 1 7